import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { LnHeroImageContainerComponent } from '../ln-hero-image-container/ln-hero-image-container.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from '../../../../environments/environment';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-hero',
  imports: [LnHeroImageContainerComponent, TranslocoPipe, NgClass],
  templateUrl: './ln-hero.component.html',
  styleUrl: './ln-hero.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnHeroComponent implements OnInit, OnDestroy {
  private swapImage = new Subscription();
  protected bucked = environment.GOOGLE_STORAGE_URL + '/imagenes/';
  private logo1 = this.bucked + environment.banners.LOGO1;
  private logo2 = this.bucked + environment.banners.LOGO2;
  private logo3 = this.bucked + environment.banners.LOGO3;
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;

  imageUrl: string[] = [this.logo1, this.logo2, this.logo3];
  activeImageIndex = signal(0);
  ngOnInit(): void {
    this.SwapImage();
  }

  SwapImage(): void {
    this.swapImage = interval(3000).subscribe(() => {
      this.activeImageIndex.set((this.activeImageIndex() + 1) % this.imageUrl.length);
    });
  }
  ngOnDestroy() {
    if (this.swapImage) {
      this.swapImage.unsubscribe();
    }
  }

  get ActiveImage(): string {
    return this.imageUrl[this.activeImageIndex()];
  }
}
